import React, { FC } from 'react'

// Constants
import { useFlag } from 'constants/flags'

// Components
import {
  WorkspaceSubscribePlan as WorkspaceSubscribePlanV1,
  WorkspaceSubscribePlanProps as WorkspaceSubscribePlanV1Props,
} from './WorkspaceSubscribePlan'
import {
  WorkspaceSubscribePlan as WorkspaceSubscribePlanV2,
  WorkspaceSubscribePlanProps as WorkspaceSubscribePlanV2Props,
} from './WorkspaceSubscribePlanV2'

export const WorkspaceSubscribePlan: FC<
  WorkspaceSubscribePlanV1Props | WorkspaceSubscribePlanV2Props
> = props => {
  // Remove usages of 'onboarding-licenses-signup' feature flag
  // https://github.com/sketch-hq/Cloud/issues/10012
  const isOnboardingLicensesSignUpOn = useFlag('onboarding-licenses-signup')

  return isOnboardingLicensesSignUpOn ? (
    <WorkspaceSubscribePlanV2 {...(props as WorkspaceSubscribePlanV2Props)} />
  ) : (
    <WorkspaceSubscribePlanV1 {...(props as WorkspaceSubscribePlanV1Props)} />
  )
}
